import { useMemo } from 'react';
import { displayNameToInitials } from '../../lib/displayUtils';
import SVGTextStyle from '../baseStyledComponents/SVGTextStyle';
import { ContactSvg } from '../defaultSvgIcons/ContactSvg';
import SVGWrapper from './SVGWrapper';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const AvatarContactInitials = ({
  displayName,
  size
}) => {
  const content = useMemo(() => displayNameToInitials({
    displayName,
    aString: displayName
  }), [displayName]);
  if (!content) {
    return /*#__PURE__*/_jsx(ContactSvg, {});
  }
  return /*#__PURE__*/_jsx(Flex, {
    position: "absolute",
    inset: "0",
    alignItems: "center",
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(SVGWrapper, {
      size: size,
      children: /*#__PURE__*/_jsx(SVGTextStyle, {
        y: "55",
        children: content
      })
    })
  });
};